
//首页第一屏需要seo优化 特别是tab导航与banner
// api首页接口定义
import { newDetail, recentNews } from "@/api/news_list";

export default {
  scrollToTop: true,
  head() {
    return {
      title: this.newsData.title + "-商城源码",
      meta: [
        { name: "description", content: this.introduction },
        { name: "keywords", content: this.journalismKeywords },
      ],
    };
  },
  name: "id",
  async asyncData({ params }) {
    const id = params.id;
    const res = await newDetail(id, "1");
    return {
      newsData: res.data.data || {},
      introduction: res.data.data.introduction,
      journalismKeywords: res.data.data.journalismKeywords || "",
    };
  },
  data() {
    return {
      recentArr: [],
      preTitle: "",
      nextTitle: "",
    };
  },
  methods: {
    recentNews() {
      recentNews()
        .then((res) => {
          this.recentArr = res.data.data || [];
        })
        .catch((err) => {
          //error do something
        });
    },
  },
  created() {},
  async mounted() {
    this.recentNews();
  },
};
